export const orgchart = {
  en: {
    searchPlaceholder: "Search name, number or position",
    matchCount: "{count} found",
    noMatches: "No match",
    goTo: "Go to",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    includeInactive: "Include former staff",
    summary: "{people} people · {roots} at the top · {depth} levels",
    anomalies: "{count} with a manager problem",
    empty: "Nobody to show yet.",
    noPosition: "No position recorded",
    noManager: "No manager recorded",
    expandReports: "Show {count} direct reports",
    collapseReports: "Hide {count} direct reports",
    totalBelow: "{count} in total below",
    directReports: "Direct reports",
    detailPanel: "Employee details",
    openProfile: "Open employee profile",
  },
  ar: {
    searchPlaceholder: "ابحث بالاسم أو الرقم أو المسمى",
    matchCount: "{count} نتيجة",
    noMatches: "لا توجد نتائج",
    goTo: "انتقل",
    expandAll: "توسيع الكل",
    collapseAll: "طي الكل",
    includeInactive: "إظهار من انتهت خدمتهم",
    summary: "{people} موظف · {roots} في القمة · {depth} مستويات",
    anomalies: "{count} لديهم مشكلة في المدير المباشر",
    empty: "لا يوجد ما يُعرض بعد.",
    noPosition: "لم يُسجَّل مسمى وظيفي",
    noManager: "لم يُسجَّل مدير مباشر",
    expandReports: "إظهار {count} من المرؤوسين",
    collapseReports: "إخفاء {count} من المرؤوسين",
    totalBelow: "{count} في الإجمالي أدناه",
    directReports: "المرؤوسون المباشرون",
    detailPanel: "بيانات الموظف",
    openProfile: "فتح ملف الموظف",
  },
} as const;
